import { useState } from 'react'
import { useCloseModal, useConfigureModalController, useModalController } from '@/atoms'

type ModalStatus = 'ready'

interface ModalData {
  simulationIds: string[]
}

type ModalProps = {
  simulations: string[]
}

export const modalId = 'deleteSimulation'
export const useController = () => useModalController<ModalData, ModalStatus>(modalId)

export const useConfigureController = ({ simulations }: ModalProps) => {
  const close = useCloseModal()

  const [options] = useState(() => ({
    createInitialState: () => ({
      status: 'ready' as ModalStatus,
      data: { simulationIds: simulations },
      close,
    }),
  }))

  return useConfigureModalController<ModalData, ModalStatus>(modalId, options)
}
